import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty} from 'lodash';
import CollegeTabNav from 'shared/college-profile/containers/college-tab-nav';
import Layout from 'shared/college-profile/containers/layout';
import {connectComponent} from 'shared/college-profile/containers/right-rail';
import Rules from './Rules';
import RightRail from './RightRail';

const ConnectedRightRail = connectComponent(RightRail);

export default class CollegeProfile extends React.Component {
  static propTypes = {
    getUserInfo: PropTypes.func.isRequired,
    student: PropTypes.shape({
      currentInstitution: PropTypes.shape({
        schoolId: PropTypes.string,
      }),
    }).isRequired,
  };

  componentDidMount() {
    this.props.getUserInfo();
  }

  render() {
    const {student} = this.props;

    if (isEmpty(student) || !student.currentInstitution) return null;

    return (
      <Layout
        RightRail={ConnectedRightRail}
        id={student.currentInstitution.schoolId}
        getUserInfo={this.props.getUserInfo}
      >
        <CollegeTabNav
          RightRail={ConnectedRightRail}
          showAbout
          Requirements={Rules}
          hideRequirements={({unsanitizedPartnerOngoingRequirements}) =>
            !unsanitizedPartnerOngoingRequirements || !unsanitizedPartnerOngoingRequirements.length
          }
          customRequirementsTitle="Rules"
          linkToScholarshipDetails
          showRightRailOnScholarships
          collapseCardsOnMobile={false}
          showCollegeDetailNav={false}
        />
      </Layout>
    );
  }
}
